/* eslint-disable import/no-cycle */
import axios from 'axios';
import { logout } from '../actions/authentication';
import { store } from '../store/store';
import { LOGOUT_PATH } from './paths'

const baseURL = process.env.REACT_APP_API_URL;

export const API = axios.create();

API.defaults.baseURL = baseURL;

export const saveTokens = ( { accessToken } ) => {
	localStorage.setItem( 'accessToken', accessToken );
};

export const removeTokens = () => {
	localStorage.removeItem( 'accessToken' );
};

export const getHeader = () => {
	const accessToken = localStorage.getItem( 'accessToken' );
	return { Authorization: `Bearer ${accessToken}`}
}

export const getBaseUrl = () => {
	return baseURL
}

// Interceptor response
API.interceptors.response.use(
	( response ) => response,
	( error ) => {
		const { response: { status } } = error;
		const url = error.response.config.url
		if ( status == 401 && !url.includes(LOGOUT_PATH)) {
			store.dispatch( logout() );
		}
		return Promise.reject( error );
	}
);

// Interceptor request
API.interceptors.request.use( ( config ) => {
	const accessToken = localStorage.getItem( 'accessToken' );
	config.headers.Authorization = `Bearer ${accessToken}`;
	return config;
} );
